export const callIncomingWithParametersConvert = (
  integrationName: string,
  request: any,
  parameters: any,
  headers: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncomingWithParametersConvert(
      integrationName,
      thingId ? thingId : 0,
      request,
      parameters,
      headers,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const callIncomingConvert = (
  integrationName: string,
  request: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncomingConvert(
      integrationName,
      thingId ? thingId : 0,
      request,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const callIncoming = (
  integrationName: string,
  request: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncoming(
      integrationName,
      thingId ? thingId : 0,
      request,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const callIncomingDataEntry = (
  integrationName: string,
  request: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncomingDataEntry(
      integrationName,
      thingId ? thingId : 0,
      request,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const callIncomingWithParameters = (
  integrationName: string,
  request: any,
  parameters: any,
  headers: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncomingWithParameters(
      integrationName,
      thingId ? thingId : 0,
      request,
      parameters,
      headers,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const callIncomingDataEntryWithParameters = (
  integrationName: string,
  request: any,
  parameters: any,
  headers: any,
  thingId?: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.integration.callIncomingDataEntryWithParameters(
      integrationName,
      thingId ? thingId : 0,
      request,
      parameters,
      headers,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}
